'use strict';

/*!
 * set global(window) app config / data object
 */
window.wsUrl = window.wsUrl || 'localhost';
window.wsPort = window.wsPort || 8888;
window.prolineApp = {
    baseConnectionString: 'wss://' + window.wsUrl + ':' + window.wsPort + '/',
    prolineAppDataKey: 'prolineApp',
    prolineAppData: {},
    data: {}
};

const getBaseConnectionString = () => window.prolineApp.baseConnectionString;
const getProlineAppDataKey = () => window.prolineApp.prolineAppDataKey;
const getProlineAppData = () => window.prolineApp.prolineAppData;
const getProlineAppDataByKey = (key) => window.prolineApp.prolineAppData[key];
const getConfig = () => window.prolineApp.data;
const getConfigByKey = (key) => window.prolineApp.data[key];
const setConfigKey = (key, val) => {
    window.prolineApp.data[key] = val;
};
const getConnectionString = () => {
    return getConfig().connectionString;
};
const setConnectionString = (val) => {
    setConfigKey('connectionString', val);
};

export {
    getBaseConnectionString,
    getProlineAppDataKey,
    getProlineAppData,
    getProlineAppDataByKey,
    getConnectionString,
    setConnectionString,
    getConfig,
    getConfigByKey,
    setConfigKey
}
